module.exports = __webpack_public_path__ + "static/media/c1.45dcb32e.jpg";